import List from "list.js";

export function projectsList() {
  const allLists = document.querySelectorAll(".js-projects-list");

  if (!allLists) {
    return;
  }

  [].slice.call(allLists).forEach(list => {
    const options = {
      listClass: "js-projects-list-list",
      valueNames: [
        {
          data: ["ct_projects_subjects"],
        },
        {
          data: ["ct_projects_status"],
        },
      ],
    };
    const projectList = new List(list, options);

    const currentFilters = {
      ct_projects_subjects: [],
      ct_projects_status: [],
    };
    const filters = list.querySelectorAll(".js-project-filter-item");

    if (filters) {
      [].slice.call(filters).forEach(filter => {
        filter.addEventListener("change", e => {
          const filter = e.target;
          const isActive = filter.checked;
          const taxonomy = filter.dataset.filterTaxonomy;
          const term = filter.name;

          if (isActive) {
            if (!currentFilters[taxonomy].includes(term)) {
              currentFilters[taxonomy].push(term);
            }
          } else {
            const updatedTerms = currentFilters[taxonomy].filter(val => val !== term);
            currentFilters[taxonomy] = updatedTerms;
          }

          // Apply the filters
          projectList.filter(item => {
            const values = item.values();

            const subjects = values["ct_projects_subjects"] ? values["ct_projects_subjects"].split(" ") : false;
            const status = values["ct_projects_status"] ? values["ct_projects_status"].split(" ") : false;

            // Show everything if no filter is active
            if (
              currentFilters["ct_projects_status"].length === 0 &&
              currentFilters["ct_projects_subjects"].length === 0
            ) {
              return true;
            }

            let hasSubjects = false;
            let hasStatus = false;

            if (subjects) {
              hasSubjects =
                currentFilters["ct_projects_subjects"].length === 0 ||
                currentFilters["ct_projects_subjects"].some(r => subjects.includes(r));
            } else if (currentFilters["ct_projects_subjects"].length === 0) {
              hasSubjects = true;
            }

            if (status) {
              hasStatus =
                currentFilters["ct_projects_status"].length === 0 ||
                status.some(r => currentFilters["ct_projects_status"].includes(r));
            } else if (currentFilters["ct_projects_status"].length === 0) {
              hasStatus = true;
            }

            if (hasStatus && hasSubjects) {
              return true;
            }

            return false;
          });
        });
      });

      // Check for URL params
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      if (urlParams.has("project-subjects") || urlParams.has("project-status")) {
        const subjectsParam = urlParams.get("project-subjects");
        const statusParam = urlParams.get("project-status");

        if (subjectsParam) {
          const subjects = subjectsParam.split(",");
          activateFilters(subjects, "ct_projects_subjects");
        }

        if (statusParam) {
          const status = statusParam.split(",");
          activateFilters(status, "ct_projects_status");
        }
      }
    }
  });
}

function activateFilters(terms, taxonomy) {
  terms.forEach(term => {
    // Find the filter item for this term and check it
    const filterItem = document.querySelector(`input[data-filter-taxonomy="${taxonomy}"][name="${term}"]`);

    if (filterItem) {
      filterItem.click();
    }
  });
}
